import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import GlobalOrgRegistryMappingsDetails from './global-org-registry-mappings-details';

const GlobalOrgRegistryMappings = () => {
  const navigate = useNavigate()
  
  const back = () => {
    navigate('/management/organization/dbn/dbnp-registries')
  }
  const { orgRegistryId,id} = useParams()
  return (
    <>
      
        <GlobalOrgRegistryMappingsDetails
        orgRegistryId={orgRegistryId}
        id={id}
          back={back}
         
        />
      
    </>
  )

}

export default GlobalOrgRegistryMappings;